module.exports = __webpack_public_path__ + "img/DeclaracionAnual.e23c71a8.png";